import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { catchError, finalize, distinctUntilChanged } from 'rxjs/operators';
import { BehaviorSubject, Observable ,  of } from 'rxjs';
import { UserService } from '../../../shared/services';
import { IPagination, IUser } from '../../../shared/models/ipagination.model';
import { DataTableParams } from 'angular-datatables-all-versions';
import { NgDataTableSortFormatterUtility } from '../../../shared/common/tools/ngdatatablesort-formatter.utility';
import { LoaderService } from 'app/shared/services/loader.service';

export class UserDataSource implements DataSource<IUser> {

  private usersSubject = new BehaviorSubject<IUser[]>([]);
  private paginationSubject = new BehaviorSubject<IPagination>({} as IPagination);
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private ngDataTableSortFormatterUtility = new NgDataTableSortFormatterUtility();

  public pagination = this.paginationSubject.asObservable().pipe(distinctUntilChanged());
  public loading$ = this.loadingSubject.asObservable();

  constructor(private service: UserService, private loaderService: LoaderService) { }

  connect(_collectionViewer: CollectionViewer): Observable<IUser[]> {
    return this.usersSubject.asObservable();
  }

  disconnect(_collectionViewer: CollectionViewer): void {
    this.usersSubject.complete();
    this.loadingSubject.complete();
    this.paginationSubject.complete();
  }

  load(search = '', offset = 1, limit = 5, sort = null, search_assoc = '', user_type = '') {
    this.loaderService.show();
    this.loadingSubject.next(true);
    this.service.find({ offset, limit, search, search_assoc, user_type } as DataTableParams).pipe(
      catchError(() => of([])),
      finalize(() => this.loadingSubject.next(false))
    ).subscribe((data: IPagination) => {
      if (data && data.users) {
        this.usersSubject.next(data.users);
      } else {
        this.usersSubject.next([]);
      }

      if(sort) {
        let list = data.users;

        list = list.sort((item1, item2) => {
          const sortAsc = sort['sortAsc'];
          let fieldToSort = sort['sortBy'];
          let firstVal;
          let secondVal;

          firstVal = this.ngDataTableSortFormatterUtility.resolveObjectValue(fieldToSort, item1);
          secondVal = this.ngDataTableSortFormatterUtility.resolveObjectValue(fieldToSort, item2);

          firstVal = firstVal ? typeof firstVal==='string' ? firstVal.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") : firstVal : '';
          secondVal = secondVal ? typeof secondVal==='string' ? secondVal.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") : secondVal : '';

          return sortAsc ?
            firstVal<secondVal ? -1 : firstVal>secondVal ? 1 : 0
            :
            firstVal<secondVal ? 1 : firstVal>secondVal ? -1 : 0;
        });

        data.users = list;
      }

      this.paginationSubject.next(data);
      this.loaderService.hide();
    });
  }

  compare(a, b, isAsc) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
}
